import { render, staticRenderFns } from "./PickupDelivery.vue?vue&type=template&id=723cc896&lang=pug"
import script from "./PickupDelivery.vue?vue&type=script&lang=js"
export * from "./PickupDelivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports